import React, { useState, useEffect } from 'react'
import { withStyles, Paper, Popper, List } from '@material-ui/core';
import PropTypes from 'prop-types';
import ListElement from './ListElement';

const style = theme => ({
	root: {
		zIndex: theme.zIndex.tooltip,
	},
})

function NewProcedureMenu({
	classes,
	anchorEl,
	onClose = () => { },
	items,
	placement = 'right-start',
}) {
	const [anchorItem, setAnchorItem] = useState(null)

	useEffect(() => {
		if (Boolean(anchorItem)) {
			setAnchorItem(null)
		}
		// eslint-disable-next-line
	}, [anchorEl])

	const handleClickElement = item => (e) => {
		if (Boolean(item.onClick)) {
			item.onClick();
			onClose();
		}
	}

	const handleMouseEnter = item => e => {
		if (Boolean(item.items)) {
			setAnchorItem({
				anchorEl: e.currentTarget,
				...item,
			})
			return;
		}
	}

	const handleMouseLeave = e => {
		if (e.relatedTarget.attributes.role === undefined) {
				onClose();
		}
	}

	const createSubMenu = () => {
		if (Boolean(anchorItem) && Boolean(anchorItem.items)) {
			return <NewProcedureMenu
				classes={classes}
				items={anchorItem.items}
				anchorEl={anchorItem.anchorEl}
				placement='right-start'
				onClose={onClose}
			/>
		}
		return '';
	}

	return (
		<>
			<Popper
				className={classes.root}
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				placement={placement}
				onMouseLeave={handleMouseLeave}
			>
				<Paper>
					<List>
						{items.map((item, i) => (
							<ListElement
								key={i}
								label={item.label}
								disabled={item.disabled}
								onClick={handleClickElement(item)}
								onMouseEnter={handleMouseEnter(item)}
							/>
						))}
					</List>
				</Paper>
			</Popper>

			{createSubMenu()}
		</>
	)
}

NewProcedureMenu.propTypes = {
	classes: PropTypes.any,
}

NewProcedureMenu.defaultProps = {
}

export default withStyles(style)(NewProcedureMenu);